import React, { useEffect, useState, useRef, useCallback } from "react";
import MROFullScreenRightDrawer from "../../../../components/fullwidth_dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import BackIcon from "@material-ui/icons/KeyboardBackspace";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import GeneralWorkOrderDetails from "./general_work_order_details";
import { TabSectionBar } from "../../../../components/tab_component";
import Divider from "@material-ui/core/Divider";
import ListingService from "../../../../lib/services/api/listing_service";
import LoadingIndicator from "../../../../components/universal/loading_indicator";
import SectionDetail from "./section_detail";
import FormDataProvider from "../../../../lib/contexts/form_context";
import LineCustomerServiceNew from "lib/services/api/admin/line/line_customers_client";


const useStyles = makeStyles(theme => ({
    appBar: {
        backgroundColor: "#fff",
        color: '#000000CC',
        boxShadow: "0px 3px 6px #0000001A",
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    wrapper: {
        margin: '3%'
    },
    detail: {
        padding: '3%',
        backgroundColor: "#fff",
        boxShadow: "0px 3px 6px #0000001A",
    }
}));

function EditWorkOrder(props) {

    const classes = useStyles();
    const { handleClose, currentSelection } = props;
    const [currentTab, setCurrentTab] = useState(0);
    const [navMenu, setNavMenu] = useState([]);
    const [loading, setLoading] = useState(false);
    const [regCharactersLength, setRegCharactersLength] = useState(null);
    const sectionDetailRef = useRef(null);  // 👈 add this

    const handleTabChange = useCallback((newTab) => {  // 👈 add this
        if (sectionDetailRef.current) {
            sectionDetailRef.current.submitForm();
        }
        setCurrentTab(newTab);
    }, []);
    useEffect(() => {
        const params = {
            line_customer_id: currentSelection.line_customer_id || 72,
            id: currentSelection.id
        }
        setLoading(true);
        ListingService.getData(params, 'workOrderSections').then((res) => {
            if (res.sections) {
                const sections = [];
                for (let i = 0;i < res.sections.length;i++) {
                    let obj = {
                        label: <div>{res.sections[i].section_name}</div>,
                        id: res.sections[i].org_section_id
                    }
                    sections.push(obj);
                }
                setNavMenu(sections);
                setCurrentTab(res.sections[0].org_section_id)
            }
            setLoading(false);
        })

        LineCustomerServiceNew.getLineCustomerDetails({
            line_customer_id: currentSelection.line_customer_id,
        })
            .then((res) => {
                if (res.success) {
                    setRegCharactersLength(Number(res.line_customer.reg_characters));

                }
            })
            .catch((err) => console.log("error", err));


    }, [currentSelection.id]);


    const onClose = useCallback(() => {
        if (sectionDetailRef.current) {
            sectionDetailRef.current.submitForm();
        }
        handleClose()
        props.getList()
    }, []);
    return (
        <MROFullScreenRightDrawer open={true}>
            <AppBar position="static" className={classes.appBar} elevation={0}>
                <Toolbar>
                    <IconButton onClick={onClose} edge="start" className={classes.backButton} color="inherit"
                        aria-label="back">
                        <BackIcon />
                    </IconButton>
                    <Typography variant="subtitle2" style={{ fontSize: "17px" }}>
                        Edit Work Order
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.wrapper}>
                <GeneralWorkOrderDetails
                    permission={props.permission}
                    getList={props.getList}
                    handleClose={handleClose}
                    data={currentSelection}
                    apiEndpoint="updateWorkOrder"
                    paramName="work_order_number"
                    bases={props.bases}
                    lineCustomerId={currentSelection.line_customer_id}
                    regCharactersLength={regCharactersLength}

                />
            </div>
            {!loading ? <div className={classes.wrapper} style={{ marginTop: '0.5%' }}>
                <TabSectionBar
                    {...props}
                    tabProperties={navMenu}
                    currentTab={currentTab}
                    setCurrentTab={handleTabChange}  // 👈 changed from setCurrentTab
                />
                <Divider variant="fullWidth" style={{ padding: '1px', backgroundColor: 'rgba(222, 214, 214, 0.2)' }} />
                <div className={classes.detail}>
                    <FormDataProvider>
                        <SectionDetail
                            ref={sectionDetailRef}  // 👈 add this
                            bases={props.bases}
                            wo_details={currentSelection}
                            data={currentSelection}
                            permission={props.permission}
                            handleClose={handleClose}
                            sectionId={currentTab}
                            lineCustomerId={currentSelection.line_customer_id}
                            workOrderId={currentSelection.id}
                            getList={props.getList}
                            baseStationId={currentSelection.base_station_id}
                        />
                    </FormDataProvider>
                </div>
            </div> : <div><LoadingIndicator variant={"block"} /></div>}
        </MROFullScreenRightDrawer>
    )
}

export default React.memo(EditWorkOrder);